<template>
  <div>
    <h2>Imagem</h2>
    <form action="" class="md-layout" @submit.prevent="submit">
      <md-field
        :class="{
          'md-invalid': !!error,
        }"
      >
        <label>Imagem</label>

        <md-file accept="image/*" @md-change="changeFile" />
        <span v-if="error" class="md-error">{{ error }}</span>
      </md-field>

      <div class="mt-3" style="text-align: right; width: 100%">
        <md-button class="md-raised md-accent" @click="() => $emit('close')">
          Cancelar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          {{ isEdit ? 'Editar' : 'Cadastrar' }}
        </md-button>
      </div>

      <img v-if="imageUrl" :src="imageUrl" alt="" />
    </form>
  </div>
</template>

<script>
import { ComponenteTipo } from '@/utils/componente'

import http from '../../../utils/http'

export default {
  name: 'ViewImageForm',
  props: {
    localId: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      url: null,
      file: null,
      imageUrl: null,
      error: null,
    }
  },
  computed: {
    isEdit() {
      return this.componente !== null
    },
  },
  async beforeMount() {
    if (this.componente !== null) {
      this.imageUrl = this.componente.value.imageUrl
    }
  },
  methods: {
    changeFile(files) {
      this.file = files[0]
      this.imageUrl = URL.createObjectURL(this.file)
    },
    async uploadTempImage() {
      if (this.file === null) {
        return -1
      }

      const form = new FormData()
      form.append('file', this.file)

      const response = await http.postForm(`temp-file/`, form, false)

      return response.id
    },
    async submit() {
      if (this.file === null && this.isEdit === false) {
        this.error = 'Selecione uma imagem'
        return
      }

      this.error = null

      let response

      const value = {
        tempFileId: await this.uploadTempImage(),
      }

      if (this.isEdit) {
        response = await http.put(`/view/componente`, {
          id: this.componente.id,
          z: this.componente.z,
          value: value,
        })
      } else {
        response = await http.post(`/view/componente`, {
          tipo: ComponenteTipo.ImageView,
          viewId: this.viewId,
          value: value,
        })
      }

      if (response) {
        this.$emit('close')
        this.$emit('updated')
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style scoped></style>
